import { Component, Input } from '@angular/core';
import {
	FormArray,
	FormBuilder,
	FormControl,
	FormGroup,
	Validators,
} from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import {
	doGetInvalidControlsList,
	doTouchAllFields,
	WrapperWorkflowActionDto,
	WrapperWorkflowStatusDto,
	WrapperWorkflowStepDto,
} from '../../workflow-utils';
import {
	FileUploadDto,
	WorkflowActionTypeEnum,
	WorkflowStepDto,
	WorkflowStepStatusDto,
} from '../../../../../service/dto';
import { HttpWorkflowService } from '../../../../../service/http-workflow.service';
import { NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { HttpFileService } from '../../../../../service/http-file.service';
import { finalize, Subscription } from 'rxjs';
import { HttpEventType } from '@angular/common/http';

export class StepAndStatusTuple {
	step!: WorkflowStepDto;
	status!: WorkflowStepStatusDto;
	get id(): number {
		return this.status.id;
	}
}
@Component({
	selector: 'app-workflow-form-action',
	standalone: false,
	templateUrl: './workflow-form-action.component.html',
	styleUrl: './workflow-form-action.component.scss',
})
export class WorkflowFormActionComponent {
	@Input() input!: WrapperWorkflowActionDto;
	@Input() mode!: 'Workflow' | 'ProductWorkflow';
	actionTypes: WorkflowActionTypeEnum[] = []; //['SplitTicketGroup', 'RequiredCommunication', 'AdditionalCommunication', 'Movement', 'CancelTicket', 'CloseTicket', 'CancelForm', 'SaveForm','AdditionalComment'];
	emailPlaceholders: any;
	attachments: NzUploadFile[] = [];

	constructor(
		private fb: FormBuilder,
		private modalRef: NzModalRef,
		private workflowService: HttpWorkflowService,
		private fileService: HttpFileService,
	) {}
	ngOnInit(): void {
		if (this.isProductWorkflow) {
			this.actionTypes = [
				'RequiredCommunication',
				'AdditionalCommunication',
			];
			if (
				!this.input.payload.id ||
				(this.input.payload.id < 0 &&
					this.input._actionType != 'RequiredCommunication' &&
					this.input._actionType != 'AdditionalCommunication')
			) {
				this.input.formGroup
					.get('actionType')!
					.setValue('RequiredCommunication');
			}
		} else {
			this.actionTypes = [
				'SplitTicketGroup',
				'RequiredCommunication',
				'AdditionalCommunication',
				'Movement',
				'CancelTicket',
				'CloseTicket',
				'CancelForm',
				'SaveForm',
				'AdditionalComment',
				'ProductValidate',
				'ProductCreateBeneficiary',
				'ProductScheduleBenefitPayment',
				'ProductApprovalQueue',
				'ProductApprovalApprove',
				'ProductApprovalDecline',
				'ForkTicket',
				'InvoiceApprovalQueue',
				'InvoiceApprovalApprove',
				'InvoiceApprovalDecline',
				'InvoiceCreate',
				'InvoiceSchedulePayment',
			];
		}

		const workflow = this.input.parent.parent.parent;
		this.workflowService
			.getEmailPlaceholders(
				workflow.payload.id,
				this.input.parent.parent.parent.postBody,
			)
			.subscribe((result) => (this.emailPlaceholders = result));

		this.attachments = (this.input.payload.attachments ?? []).map(
			(file) =>
				({
					uid: file.uuid,
					name: file.fileName || file.name,
					status: 'done',
				}) as NzUploadFile,
		);
	}
	get availableMovements(): StepAndStatusTuple[] {
		return this.input.parent.parent.parent.steps
			.map((step) =>
				step.statuses.map((item) => {
					const out = new StepAndStatusTuple();
					out.status = item.payload;
					out.step = step.payload;
					return out;
				}),
			)
			.flat();
	}
	compareSelectValues = (o1: any, o2: any): boolean =>
		o1 && o2 ? o1.id === o2.id : o1 === o2;

	// get nextSteps(): WrapperWorkflowStepDto[] {
	// 	const thisStep = this.input.parent.parent;
	// 	return this.input.parent.parent.parent.steps.filter(item => item != thisStep);
	// }
	// get nextStates(): WrapperWorkflowStatusDto[] {
	// 	const nextStepAction = this.input.parent.actions.filter(item => item._actionType == 'ChangeStep').sort((i1, i2) => i1._orderIndex - i2._orderIndex)[0];
	// 	if (nextStepAction) {
	// 		const nextStep = this.input.parent.parent.parent.steps.filter(item => item.payload.id == +nextStepAction._actionValue!)[0];
	// 		if (nextStep) {
	// 			return nextStep.statuses;
	// 		}
	// 	}
	// 	return this.input.parent.parent.statuses;
	// }
	doTouchAllFields(group: FormGroup | FormArray) {
		Object.values(group.controls).forEach((control) => {
			if (control instanceof FormControl) {
				control.markAsDirty({ onlySelf: true });
				control.updateValueAndValidity({ onlySelf: true });
			} else if (
				control instanceof FormGroup ||
				control instanceof FormArray
			) {
				this.doTouchAllFields(control);
			}
		});
	}
	doClose() {
		this.modalRef.close({ action: 'close' });
	}
	doDelete() {
		console.log('Closing modal');
		this.modalRef.close({ action: 'delete', value: this.input });
	}

	touchAllFields() {
		doTouchAllFields(this.input.formGroup);
	}
	getInvalidControlsList() {
		return doGetInvalidControlsList(this.input.formGroup);
	}

	customUpload = (item: NzUploadXHRArgs): Subscription => {
		const formData = new FormData();
		formData.append('file', item.file as any);

		// Create the subscription
		const sub = this.fileService
			.upload(item.name ?? 'attachment-' + Date.now(), formData)
			.subscribe({
				next: (res) => {
					// success callback
					item.onSuccess!(res, item.file, event);
					console.log('Upload result: ' + res.uuid);
					(
						this.input.formGroup.get('attachments')! as FormArray
					).push(new FormControl(res));
					this.input.payload.attachments?.push(res);
				},
				error: (err) => {
					item.onError!(err, item.file);
				},
			});

		// return it so nz-upload can cancel if needed
		return sub;
	};

	onRemove = (file: NzUploadFile) => {
		// optionally call backend to delete
		console.log('Removing', file);
		return true;
	};

	doGetControlsList(
		group: FormGroup | FormArray,
		path: string = '',
	): string[] {
		let out: string[] = [];
		Object.keys(group.controls).forEach((key) => out.push(key));
		return out;
	}
	get isProductWorkflow(): boolean {
		return this.mode == 'ProductWorkflow';
	}
	get isReadOnly() {
		if (!this.isProductWorkflow) {
			return false;
		}
		if (this.input.payload.linkedToProduct == false) {
			return true;
		}
		return (
			this.input._actionType != 'RequiredCommunication' &&
			this.input._actionType != 'AdditionalCommunication'
		);
	}
}
